import { memo, type FC } from "react";
import type { Image as ImageType } from "@graphql/generated/components";
import { getImageAltTag } from "@lib/utils/attributesUtils";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { ImageWithVideo } from "@pages/product/[productName]/[articleNumber]/[colorCode]";
import { ProductImageThumbnail } from "./ProductImageThumbnail";
import { ProductVideoThumbnail } from "./ProductVideoThumbnail";

interface IProductImagesThumbnailProps {
    images: ImageType[] | ImageWithVideo[];
    setImageIndex: (index: number) => void;
    altTagPattern?: string;
    imageIndex: number;
}

export const ProductImagesThumbnails: FC<IProductImagesThumbnailProps> = memo(
    ({ images, setImageIndex, altTagPattern, imageIndex }) => {
        return (
            <Flex
                w="100%"
                maxW={"10.4"}
                h="auto"
                position="sticky"
                top={16}
                left={5}
                flexDir={"column"}
                gap={0.5}
            >
                {images.map((image, i) => {
                    return image.video720 || image.video ? (
                        <ProductVideoThumbnail
                            key={image.url}
                            index={i}
                            currentlySelected={imageIndex === i}
                            image={image}
                            alt={getImageAltTag(altTagPattern, image.label)}
                            setImageIndex={setImageIndex}
                        />
                    ) : (
                        <ProductImageThumbnail
                            key={image.url}
                            index={i}
                            currentlySelected={imageIndex === i}
                            image={image}
                            alt={getImageAltTag(altTagPattern, image.label)}
                            setImageIndex={setImageIndex}
                        />
                    );
                })}
            </Flex>
        );
    }
);

ProductImagesThumbnails.displayName = "ProductImagesThumbnails";

export default ProductImagesThumbnails;
